import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import api from '../services/api';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token') || null);
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'));

  const isAuthenticated = computed(() => !!token.value);

  const login = async (credentials) => {
    try {
      const response = await api.post('/api/account/login', credentials);
      const { token: authToken, user: userData } = response.data;
      token.value = authToken;
      user.value = userData;
      localStorage.setItem('token', authToken);
      localStorage.setItem('user', JSON.stringify(userData));
      return { success: true };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || '登录失败' };
    }
  };

  const logout = () => {
    token.value = null;
    user.value = null;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const getUserInfo = async () => {
    try {
      const response = await api.get('/api/protected/userinfo');
      user.value = response.data;
      localStorage.setItem('user', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      logout();
      throw error;
    }
  };

  return { token, user, isAuthenticated, login, logout, getUserInfo };
});
